import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

let refreshPromise = null;

export async function refreshAccessToken() {
  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/user/refresh`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });

      const text = await res.text();
      let data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch {
        data = null;
      }

      const success = res.ok && (data?.success ?? true);
      return {
        success,
        code: data?.code,
        ...normalizeApiMessage(data),
        status: res.status,
      };
    } catch (err) {
      console.error("refreshAccessToken failed:", err);
      return {
        success: false,
        code: "REFRESH_FETCH_ERROR",
        message: "Network error",
        messageKey: "api.common.networkError",
      };
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
}
